import { useState } from "react"
import { XMarkIcon } from "@heroicons/react/20/solid"
import * as Sentry from "@sentry/nextjs";
import { toastMessage } from "@/(front-desk)/utils/functions";
import { useTranslation } from "@/(front-desk)/hooks/useTranslation";
import locales from "./Report.i18n";

export default function Report(props) {
    const { t } = useTranslation(locales);
    const eventId = Sentry.captureMessage("User Feedback");

    const [ reportData, setReportData ] = useState({
        associatedEventId: eventId,
        name: '',
        email: '',
        message: ''
    })

    function valueChange(key, value) {
        setReportData(reportData => {
            const data = Object.assign({}, reportData)
            data[key] = value
            return data
        })
    }
    function handleReport(e) {
        e.preventDefault()
        Sentry.captureFeedback(reportData)
        props.setReportPopup(false)
        toastMessage('success', t('successMessage'))
    }

    return (
        <div className="popup !block overflow-y-scroll">
            <div className="popup-content pt-16 !max-w-[36rem] !h-fit m-auto">
                <button
                    className="btn btn-close"
                    onClick={() => {props.setReportPopup(false)}}
                >
                    <XMarkIcon />
                </button>
                <div className="title mb-2">{t('title')}</div>
                <div className="text color-gray-400 mb-6">{t('description')}</div>
                <form onSubmit={handleReport}>
                    <div className="input-group mb-6">
                        <label>{t('nameLabel')}</label>
                        <input
                            type="text"
                            placeholder={t('namePlaceholder')}
                            value={reportData.name}
                            onChange={(e) => {valueChange('name', e.target.value)}}
                        />
                    </div>
                    <div className="input-group mb-6">
                        <label>{t('emailLabel')}</label>
                        <input
                            type="email"
                            placeholder={t('emailPlaceholder')}
                            value={reportData.email}
                            onChange={(e) => {valueChange('email', e.target.value)}}
                        />
                    </div>
                    <div className="input-group mb-10">
                        <label>{t('messageLabel')}</label>
                        <textarea
                            className="h-48"
                            placeholder={t('messagePlaceholder')}
                            value={reportData.comments}
                            onChange={(e) => {valueChange('comments', e.target.value)}}
                        />
                    </div>
                    <div className="flex flex-wrap gap-4 sm:flex-nowrap">
                        <button
                            className="btn btn-outline-black btn-round w-full"
                            onClick={() => {props.setReportPopup(false)}}
                            type="button"
                        >{t('cancel')}</button>
                        <button
                            className="btn btn-black btn-round w-full"
                            type="submit"
                        >{t('submit')}</button>
                    </div>
                </form>
            </div>
        </div>
    )
}
